import * as React from 'react';

const MastercardPaymentRebrandingSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#mastercard-payment-rebranding_svg__clip0_101_1051)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#000"
            />
            <path
                d="M82.651 63.992c0-10.69 4.956-20.893 13.313-27.501-15.16-11.953-37.218-9.33-49.171 5.928-11.856 15.16-9.232 37.121 6.025 49.074a34.893 34.893 0 0043.244 0 35 35 0 01-13.41-27.501z"
                fill="#EB001B"
            />
            <path
                d="M152.62 63.992c0 19.338-15.646 34.984-34.984 34.984-7.872 0-15.451-2.624-21.573-7.483 15.159-11.953 17.783-33.915 5.83-49.172-1.749-2.137-3.693-4.178-5.83-5.83 15.159-11.953 37.218-9.33 49.074 5.928 4.859 6.122 7.483 13.702 7.483 21.573z"
                fill="#F79E1B"
            />
            <path
                d="M96.063 36.49c2.138 1.652 4.081 3.694 5.83 5.831 11.953 15.257 9.329 37.219-5.83 49.172h-.002a35 35 0 01-13.41-27.501c0-10.69 4.956-20.893 13.314-27.501h.098z"
                fill="#FF5F00"
            />
        </g>
        <defs>
            <clipPath id="mastercard-payment-rebranding_svg__clip0_101_1051">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

MastercardPaymentRebrandingSvg.displayName = 'MastercardPaymentRebrandingSvg';
export default MastercardPaymentRebrandingSvg;
